import React, { useCallback } from 'react';
import log from 'loglevel';
import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
  Button,
  CardTitle,
  Label,
  CardHeader,
  Form,
  Spinner,
  ListGroup,
  ListGroupItem,
  Badge,
  Progress
} from 'reactstrap';
import { SET_PERSONA, SET_QUERY } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select2 from 'react-select2-wrapper';

export default function QueryInput() {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleChange = useCallback((e) => {
    // Handle input change
    const query = e.target.value;
    log.debug('Query Input Changed:', query);
  }, []);

  const masterPersona = '';

  return (
    <Card
      className="bg-gradient-primary border-0"
      style={{
        height: 140
      }}
    >
      <CardBody>
        <Row>
          <Col md="12">
            <Input
              className="form-control"
              type="text"
              placeholder="Ask a question about your customers..."
              style={{
                zIndex: 100000000,
                position: 'absolute',
                width: '90%',
                top: 5
              }}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  // Set persona
                  dispatch({
                    type: SET_PERSONA,
                    payload: {
                      persona: masterPersona
                    }
                  });

                  // Set initial query
                  if (query.length > 0) {
                    dispatch({
                      type: SET_QUERY,
                      payload: {
                        query
                      }
                    });
                  }

                  // Go to agent
                  history.push('/admin/knowledge/agent');
                }
              }}
              disabled
            />
            <div
              className="icon icon-shape bg-white text-dark rounded-circle shadow"
              style={{
                zIndex: 200000000,
                position: 'absolute',
                right: '2%',
                top: -2,
                height: 80,
                width: 80
              }}
            >
              <i className="ni ni-books" />
            </div>
          </Col>
          <Col
            md="12"
            style={{
              paddingTop: 65
            }}
          >
            <Button
              onClick={() => {
              // Select persona
                const topic = {
                  name: 'Freshness Guarantee',
                  description: 'their commitment to providing premium, fresh Maine lobsters directly to your doorstep, ensuring the highest quality and taste'
                };

                // Set persona
                dispatch({
                  type: SET_PERSONA,
                  payload: {
                    persona: masterPersona
                  }
                });

                dispatch({
                  type: SET_QUERY,
                  payload: {
                    query: `Can you tell me more about how you evaluate retailers like us on their ${topic.name}. Specifically, ${topic.description}.`
                  }
                });

                // Go to agent
                history.push('/admin/knowledge/agent');
              }}
              color="default"
              size="sm"
              type="button"
            >
              freshness guarantee
            </Button>
            <Button
              onClick={() => {
              // Select persona
                const topic = {
                  name: 'Source and Sustainability',
                  description: 'their dedication to sourcing authentic Maine lobsters sustainably and supporting local fishermen and communities in the process'
                };

                // Set persona
                dispatch({
                  type: SET_PERSONA,
                  payload: {
                    persona: masterPersona
                  }
                });

                dispatch({
                  type: SET_QUERY,
                  payload: {
                    query: `Can you tell me more about how you evaluate retailers like us on their ${topic.name}. Specifically, ${topic.description}.`
                  }
                });

                // Go to agent
                history.push('/admin/knowledge/agent');
              }}
              color="default"
              size="sm"
              type="button"
            >
              source and sustainability
            </Button>
            <Button
              onClick={() => {
              // Select persona
                const topic = {
                  name: 'Packaging and Presentation',
                  description: 'their ability to ensure that our lobsters are delivered in high-quality packaging, maintaining their freshness and presentation throughout the delivery process.'
                };

                // Set persona
                dispatch({
                  type: SET_PERSONA,
                  payload: {
                    persona: masterPersona
                  }
                });

                dispatch({
                  type: SET_QUERY,
                  payload: {
                    query: `Can you tell me more about how you evaluate retailers like us on their ${topic.name}. Specifically, ${topic.description}.`
                  }
                });

                // Go to agent
                history.push('/admin/knowledge/agent');
              }}
              color="default"
              size="sm"
              type="button"
            >
              packaging and presentation
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export function CustomerSummary() {
  const insights = useSelector((state) => state.insights);

  return (
    <Card>
      <CardBody>
        <CardTitle className="pb-2 mb-3 border-bottom" tag="h3">
          <span>Customer Summary</span>
        </CardTitle>
        {/* { insights.demographics.age ?
                  <Row>
                    <Col md="1"></Col>
                    <Label
                      className="form-control-label"
                      htmlFor="example-text-input"
                      md="4"
                    >
                      Age
                    </Label>
                    <Col md="6">
                      <Row className="col-form-label">
                        <div>{insights.demographics.age.toFixed(0)}</div>
                      </Row>
                    </Col>
                    <Col md="1"></Col>
                  </Row>
                  :
                  <></>
                } */}
        <Row>
          <Col md="1" />
          <Label
            className="form-control-label"
            htmlFor="example-text-input"
            md="4"
          >
            Gender
          </Label>
          <Col md="6">
            <Row className="col-form-label">
              <div>
                {insights.demographics.gender.female.toFixed(0)}
                % ∙ Female
              </div>
            </Row>
            <Row className="col-form-label">
              <div>
                {insights.demographics.gender.male.toFixed(0)}
                % ∙ Male
              </div>
            </Row>
          </Col>
          <Col md="1" />
        </Row>
      </CardBody>
    </Card>
  );
}

export function TopConvertingProducts() {
  const insights = useSelector((state) => state.insights);
  log.debug('Top Converting Products Insights:', insights);

  return (
    <Card>
      <CardHeader className="bg-transparent">
        <Form>
          <Select2
            className="form-control"
            defaultValue="1"
            options={{
              placeholder: 'Select'
            }}
            data={[
              { id: '1', text: 'Top Converting Products' }
            ]}
          />
        </Form>
      </CardHeader>
      { !insights.initialized && insights.preferences && insights.preferences.length === 0
        ? (
          <CardBody style={{
            minHeight: 350
          }}
          >
            <Row style={{
              marginTop: 150, flex: 1, justifyContent: 'center', alignItems: 'center'
            }}
            >
              <Spinner color="primary" />
            </Row>
          </CardBody>
        )
        : (
          <CardBody style={{
            minHeight: 350
          }}
          >
            <ListGroup className="list my--3" flush>
              { insights.preferences.map((concept, index) => (
                <ListGroupItem className="px-0" key={index}>
                  <Row className="align-items-center">
                    <div className="col">
                      <h5>
                        <Badge color="primary" className="mr-2">
                          {concept.value ? concept.value.toFixed(2) : 0}
                          %
                        </Badge>
                        {concept.display}
                      </h5>
                      <Progress
                        className="progress-xs mb-0"
                        color="primary"
                        max="100"
                        value={concept.value}
                      />
                    </div>
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        size="sm"
                        type="button"
                        style={{
                          width: 100
                        }}
                        onClick={() => {
                        // View customer activity drill-down
                        // history.push(`/admin/customers/insights?persona=${model.entity.name}&filter=${dimension.display}`);
                        }}
                        disabled
                      >
                        View
                      </Button>
                    </Col>
                  </Row>
                </ListGroupItem>
              ))}
            </ListGroup>
          </CardBody>
        )}
    </Card>
  );
}
